import Footer1 from './Footer1'
export default Footer1
